var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAnalysis1 = function SvgAnalysis1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 17,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M21.313 14.25H2.75V1.188C2.75.844 2.406.5 2.063.5H.687A.707.707 0 0 0 0 1.188v14.437C0 16.398.602 17 1.375 17h19.938c.343 0 .687-.3.687-.687v-1.375c0-.344-.344-.688-.687-.688M19.938 1.875h-5.114c-.902 0-1.375 1.117-.73 1.762l1.418 1.418-3.137 3.136-3.18-3.136a1.325 1.325 0 0 0-1.933 0L4.297 8.02a.674.674 0 0 0 0 .945l.988.988a.674.674 0 0 0 .945 0l2.02-1.976 3.137 3.136a1.325 1.325 0 0 0 1.933 0l4.125-4.125 1.418 1.418c.645.645 1.719.172 1.719-.73V2.563c.043-.344-.3-.688-.645-.688"
  })));
};
export default SvgAnalysis1;